import { AuthenticationMethod, Platform } from '../api';
import { CredentialKey } from './credentials.constants';

export const PlatformIconPaths: { [key: string]: string } = {
  [Platform.powerplatform]: 'assets/images/logo/ms-logo.svg',
  [Platform.powerBI]: 'assets/images/logo/power-bi-logo.svg',
  [Platform.workato]: 'assets/images/logo/workato-logo.svg',
  [Platform.salesforce]: 'assets/images/logo/salesforce-logo.png',
  [Platform.serviceNow]: 'assets/images/logo/serviceNow-logo.svg',
  [Platform.chatGptEnterprise]: 'assets/images/logo/chatGptEnterprise.svg',
  [Platform.amazonBedrock]: 'assets/images/logo/amazon-bedrock-logo.svg',
  [Platform.google]: 'assets/images/logo/google-logo.svg',
};

export const PlatformAuthDetailsDescription: {
  [key: string]: { [key: string]: { [key: string]: string } };
} = {
  [Platform.powerplatform]: {
    [AuthenticationMethod.userpassword]: {
      [CredentialKey.username]: 'integrationPage.authDescriptions.ppUserPasswordUsername',
      [CredentialKey.password]: 'integrationPage.authDescriptions.ppUserPasswordPass',
      [CredentialKey.tenantId]: 'integrationPage.authDescriptions.ppTenantId',
      [CredentialKey.clientId]: 'integrationPage.authDescriptions.ppClientId',
    },
    [AuthenticationMethod.serviceprincipal]: {
      [CredentialKey.servicePrincipalSecret]: 'integrationPage.authDescriptions.ppServicePrincipalSecret',
      [CredentialKey.tenantId]: 'integrationPage.authDescriptions.ppTenantId',
      [CredentialKey.clientId]: 'integrationPage.authDescriptions.ppClientId',
    },
    [AuthenticationMethod.ppZenityMultiTenantAppServicePrincipal]: {
      [CredentialKey.tenantId]: 'integrationPage.authDescriptions.ppTenantId',
      [CredentialKey.servicePrincipalObjectId]: 'integrationPage.authDescriptions.servicePrincipalObjectId',
    },
  },
  [Platform.powerBI]: {
    [AuthenticationMethod.ppZenityMultiTenantAppServicePrincipal]: {
      [CredentialKey.tenantId]: 'integrationPage.authDescriptions.ppTenantId',
      [CredentialKey.servicePrincipalObjectId]: 'integrationPage.authDescriptions.servicePrincipalObjectId',
    },
  },
  [Platform.workato]: {
    [AuthenticationMethod.userpassword]: {
      [CredentialKey.username]: 'integrationPage.authDescriptions.workatoUserPasswordUsername',
      [CredentialKey.password]: 'integrationPage.authDescriptions.workatoUserPasswordPass',
    },
    [AuthenticationMethod.apikey]: {
      [CredentialKey.email]: 'integrationPage.authDescriptions.workatoApiKeyEmail',
      [CredentialKey.apiKey]: 'integrationPage.authDescriptions.workatoApiKeyKey',
    },
    [AuthenticationMethod.apitoken]: {
      [CredentialKey.apiToken]: 'integrationPage.authDescriptions.workatoApiToken',
    },
    [AuthenticationMethod.oktasso]: {
      [CredentialKey.username]: 'integrationPage.authDescriptions.workatoUserPasswordUsername',
      [CredentialKey.password]: 'integrationPage.authDescriptions.workatoUserPasswordPass',
      [CredentialKey.oktaAppEmbeddedUrl]: 'integrationPage.authDescriptions.oktaAppEmbeddedUrl',
      [CredentialKey.oktaUsername]: 'integrationPage.authDescriptions.oktaUsername',
      [CredentialKey.oktaPassword]: 'integrationPage.authDescriptions.oktaPassword',
    },
  },
  [Platform.salesforce]: {
    [AuthenticationMethod.oauthClientCredentialsFlow]: {
      [CredentialKey.salesforceInstanceUrl]: 'integrationPage.authDescriptions.salesforceInstanceUrl',
      [CredentialKey.clientId]: 'integrationPage.authDescriptions.salesforceClientId',
      [CredentialKey.clientSecret]: 'integrationPage.authDescriptions.salesforceClientSecret',
    },
  },
  [Platform.serviceNow]: {
    [AuthenticationMethod.oauthAuthorizationCode]: {
      [CredentialKey.serviceNowInstanceUrl]: 'integrationPage.authDescriptions.serviceNowInstanceUrl',
      [CredentialKey.clientId]: 'integrationPage.authDescriptions.serviceNowClientId',
      [CredentialKey.clientSecret]: 'integrationPage.authDescriptions.serviceNowSecretId',
    },
  },
  [Platform.chatGptEnterprise]: {
    [AuthenticationMethod.apikey]: {
      [CredentialKey.workspaceId]: 'integrationPage.authDescriptions.chatGptEnterpriseWorkspaceId',
      [CredentialKey.apiKey]: 'integrationPage.authDescriptions.chatGptEnterpriseApiKey',
    },
  },
  [Platform.amazonBedrock]: {
    [AuthenticationMethod.iamRole]: {
      [CredentialKey.iamRoleARN]: 'integrationPage.authDescriptions.amazonBedrockIAMRoleARN',
      [CredentialKey.externalId]: 'integrationPage.authDescriptions.amazonBedrockExternalId',
      [CredentialKey.accountId]: 'integrationPage.authDescriptions.amazonBedrockAccountId',
    },
  },
  [Platform.google]: {
    [AuthenticationMethod.serviceAccount]: {
      [CredentialKey.organizationId]: 'integrationPage.authDescriptions.googleOrganizationId',
      [CredentialKey.tokenUri]: 'integrationPage.authDescriptions.googleTokenUri',
      [CredentialKey.projectId]: 'integrationPage.authDescriptions.googleProjectId',
      [CredentialKey.privateKeyId]: 'integrationPage.authDescriptions.privateKeyId',
      [CredentialKey.universeDomain]: 'integrationPage.authDescriptions.googleUniverseDomain',
      [CredentialKey.clientEmail]: 'integrationPage.authDescriptions.googleClientEmail',
      [CredentialKey.privateKey]: 'integrationPage.authDescriptions.googlePrivateKey',
    },
  },
};
